import { useCurrentCloudProvider } from '@labrav/common'
import { ExternalPlatformType } from '../../ProductListingV2/types'
import { AddEditProductListing } from '../AddEditProductListing/AddEditProductListing'
import { AddEditProductListingMicrosoft } from '../AddEditProductListingMicrosoft/AddEditProductListingMicrosoft'
import { useSyncFlyoutRouteParams } from '../../../common/utils/hooks/useSyncFlyoutRouteParams'

export const AddEditProductListingImpartnerWrapper = () => {
  const cloudMarketplace = useCurrentCloudProvider()
  if (cloudMarketplace === 'AWS') {
    return (
      <AddEditProductListing
        isImpartner={true}
        externalPlatformType={ExternalPlatformType.IMPARTNER}
      />
    )
  }
  if (cloudMarketplace === 'AZURE') {
    return (
      <AddEditProductListingMicrosoft
        isImpartner={true}
        externalPlatformType={ExternalPlatformType.IMPARTNER}
      />
    )
  }
  return null
}

export const AddEditProductListingWrapper = () => {
  useSyncFlyoutRouteParams()
  const cloudMarketplace = useCurrentCloudProvider()

  if (cloudMarketplace === 'AWS') {
    return <AddEditProductListing />
  }
  if (cloudMarketplace === 'AZURE') {
    return <AddEditProductListingMicrosoft />
  }
  return null
}

export default AddEditProductListingImpartnerWrapper
